import { BrowserCacheLocation } from "@azure/msal-browser";
import { HejMsalConfig } from "@ingka-group-digital/cwep-hej-core";

export const msalConfiguration: HejMsalConfig = {
  auth: {
    clientId:
      import.meta.env["VITE_APP_SSO_CLIENT_ID"] ??
      "Missing VITE_APP_SSO_CLIENT_ID",
    authority: `https://login.microsoftonline.com/${import.meta.env["VITE_APP_SSO_TENANT"] ?? "Missing VITE_APP_SSO_TENANT"}/v2.0`,
    redirectUri: window.location.origin,
  },
  protectedResourceScopeMap: [
    ["https://graph.microsoft.com", ["User.Read"]],
    [
      `https://hej-gateway.ingka.com/api/gateway/link`,
      ["api://fb00f820-4785-4cdd-817f-c8d2e2ddaf02/link"],
    ],
    [
      `https://hej-gateway.ingka.com/api/gateway/favorite`,
      ["api://fb00f820-4785-4cdd-817f-c8d2e2ddaf02/favorite"],
    ],
    [
      `https://hej-gateway.ingka.com/api/gateway/user`,
      ["api://fb00f820-4785-4cdd-817f-c8d2e2ddaf02/user"],
    ],
  ],
  cache: {
    // SessionStorage is required for redirect-based auth flows (acquireTokenRedirect).
    // Memory cache would wipe tokens on every page reload, breaking the redirect loop guard
    // in getAuthToken.ts. SessionStorage is preferred over LocalStorage as tokens do not
    // persist across browser sessions. Tokens here are exposed to JavaScript (no HttpOnly
    // equivalent for storage) — mitigate XSS risk via strict CSP and input sanitisation.
    cacheLocation: BrowserCacheLocation.SessionStorage,
  },
};

export const tokenScopes = ["https://atkomst.ingka.ikea.com/user.read"];
